import { useEffect, useRef } from 'react';
import { AD_CONSENT_EVENT, initAdPixels } from '@/lib/adPixels';

/** No App: carrega os pixels de anúncio se já houver consentimento, ou assim que a pessoa aceitar. */
export const useAdPixels = () => {
  useEffect(() => {
    initAdPixels();
    window.addEventListener(AD_CONSENT_EVENT, initAdPixels);
    return () => window.removeEventListener(AD_CONSENT_EVENT, initAdPixels);
  }, []);
};

/**
 * Dispara um evento de anúncio uma vez por evento esportivo. Com `waitName`, espera o nome do
 * evento carregar (vai junto no relatório da Meta e do Google).
 */
export const useAdEvent = (
  track: (input: { eventId: string; eventName?: string }) => void,
  eventId: string | undefined,
  eventName?: string,
  waitName = false
) => {
  const sentFor = useRef<string>();
  useEffect(() => {
    if (!eventId || (waitName && !eventName)) {
      return;
    }
    if (sentFor.current !== eventId) {
      sentFor.current = eventId;
      track({ eventId, eventName });
    }
    // Também quando aceitar os cookies depois de abrir a página (sem consentimento o track acima não fez nada)
    const onConsent = () => track({ eventId, eventName });
    window.addEventListener(AD_CONSENT_EVENT, onConsent, { once: true });
    return () => window.removeEventListener(AD_CONSENT_EVENT, onConsent);
  }, [track, eventId, eventName, waitName]);
};
